import { StatusBadge } from "@/components/dashboard/widgets/shared/StatusBadge";
import type { BookingState } from "@/lib/equipment/availability";
import type { EquipmentStatus } from "@/lib/equipment/constants";
import { EquipmentStatusBadge } from "./EquipmentStatusBadge";

/** Status i utstyrslista (VIB-2919): Ledig, Booket, delvis ledig, ⚠ Dobbeltbooket, eller registerstatusen. */
export function BookingStateBadge({ state, status }: { state: BookingState; status: EquipmentStatus }) {
  if (state.kind === "unavailable") return <EquipmentStatusBadge status={status} />;
  if (state.kind === "conflict") return <StatusBadge tone="miss" label={state.label} />;
  if (state.kind === "free") return <StatusBadge tone="reached" label={state.label} />;
  return <StatusBadge tone="near" label={state.label} />;
}
